import { Modal, Typography } from "antd"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { TextArea } from "../../../components/Input/TextArea.tsx"

const { Text } = Typography

interface RejectReviewModalProps {
  fileName: string
  onClose: () => void
  onSubmit: (reason: string) => Promise<void>
  /** Lets `ReviewDrawer`'s "Request Changes" action reuse this same reason-
   * collecting modal with its own copy, rather than duplicate the component
   * for what is otherwise an identical form. */
  title?: string
  submitText?: string
  reasonLabel?: string
  placeholder?: string
  danger?: boolean
}

export function RejectReviewModal({
  fileName,
  onClose,
  onSubmit,
  title,
  submitText,
  reasonLabel,
  placeholder,
  danger = true
}: RejectReviewModalProps) {
  const { t } = useTranslation()
  const [reason, setReason] = useState("")
  const [saving, setSaving] = useState(false)

  const handleSubmit = async () => {
    if (!reason.trim()) return
    setSaving(true)
    await onSubmit(reason.trim())
    setSaving(false)
  }

  return (
    <Modal
      open
      title={title ?? t("files.review.rejectTitle")}
      onCancel={onClose}
      okText={submitText ?? t("files.review.rejectSubmit")}
      okButtonProps={{ danger, disabled: !reason.trim(), loading: saving }}
      onOk={() => void handleSubmit()}
      cancelButtonProps={{ disabled: saving }}
    >
      <div className="flex flex-col gap-2">
        <Text type="secondary">{fileName}</Text>
        <Text type="secondary">{reasonLabel ?? t("files.review.rejectReason")}</Text>
        <TextArea
          autoFocus
          disabled={saving}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder={placeholder ?? t("files.review.rejectReasonPlaceholder")}
          rows={3}
          maxLength={1000}
        />
      </div>
    </Modal>
  )
}
